import { render } from "./NoahForum.vue?vue&type=template&id=7d97d9ee&scoped=true"
import script from "./NoahForum.vue?vue&type=script&lang=js"
export * from "./NoahForum.vue?vue&type=script&lang=js"

import "./NoahForum.vue?vue&type=style&index=0&id=7d97d9ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d97d9ee"]])

export default __exports__